import ModalContent from "./ModalContent";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import type { ReactNode } from "react";

export function confirm({
  title = "Please confirm",
  children,
  onConfirm,
  onCancel,
  labels,
  danger = false,
  size
}: {
  title?: string;
  children: ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  labels?: { confirm?: string; cancel?: string };
  danger?: boolean;
  size?: string | number;
}) {
  const confirmLabel = labels?.confirm ?? "Confirm";
  const cancelLabel = labels?.cancel ?? "Cancel";

  const modalId = modals.open({
    withCloseButton: false,
    closeOnClickOutside: false,
    closeOnEscape: false,
    size,
    children: (
      <>
        <ModalHeader
          title={title}
          onClose={() => {
            onCancel?.();
            modals.close(modalId);
          }}
        />
        <ModalContent>{typeof children === "string" ? <Text size="md">{children}</Text> : children}</ModalContent>
        <ModalFooter>
          <Button
            variant="light"
            color="gray"
            onClick={() => {
              onCancel?.();
              modals.close(modalId);
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="filled"
            color={danger ? "red" : undefined}
            onClick={() => {
              onConfirm?.();
              modals.close(modalId);
            }}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </>
    )
  });

  return modalId;
}
